import { graphql, useStaticQuery } from "gatsby";

export const useFeaturedLocationsAll = () => {
  const {
    featuredLocations: { edges },
  } = useStaticQuery(graphql`
    {
      featuredLocations: allMarkdownRemark(
        filter: { frontmatter: { type: { eq: "article_travel" } } }
        limit: 200
        sort: { fields: [frontmatter___timestamp_creation_utc], order: DESC }
      ) {
        edges {
          node {
            frontmatter {
              url_slug
              domain
              structure
              html_article_title_en
              html_article_title_es
              html_article_title_fr
              html_article_title_nl
              html_article_title_pt
              html_article_title_ru
              html_article_title_uk
              main_item_translated_en
              main_item_translated_es
              main_item_translated_fr
              main_item_translated_nl
              main_item_translated_pt
              main_item_translated_ru
              main_item_translated_uk
              seo_meta_description_en
              seo_meta_description_es
              seo_meta_description_fr
              seo_meta_description_nl
              seo_meta_description_pt
              seo_meta_description_ru
              seo_meta_description_uk
              images_array {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED)
                }
              }
            }
          }
        }
      }
    }
  `);
  // console.dir(
  //   {
  //     featuredLocations: featuredLocations,
  //   },
  //   {
  //     depth: 8,
  //   }
  // );
  //

  // const medges = useMemo(() => {
  //   // console.dir({
  //   //   FROM: "💙💙💙💙💙💙💙💙💙💙💙💙💙💙💙💙💙💙",
  //   // });
  //   return helpers.fisherYatesShuffle(edges);
  // }, [edges]);

  return edges;
};

/**
 * 20241007
 * removed main_item
 * need to add domain param - impossible to add domain param it is not supported in static query and page query also problematic so need by pass (use dofferent hooks etc)
 */
